import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from './lib/queryClient'
import { initializeMonitoring } from './lib/monitoring'

// Page components
import Dashboard from './pages/Dashboard'
import RunBuilder from './pages/RunBuilder'
import SharedRun from './pages/SharedRun'
import Auth from './pages/Auth'
import Settings from './pages/Settings'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import { PageErrorBoundary } from './components/ErrorBoundary'

function App() {
  useEffect(() => {
    initializeMonitoring()
  }, [])

  return (
    <PageErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/auth" element={
              <PageErrorBoundary>
                <Auth />
              </PageErrorBoundary>
            } />
            <Route path="/shared/:slug" element={
              <PageErrorBoundary>
                <SharedRun />
              </PageErrorBoundary>
            } />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={
                <PageErrorBoundary>
                  <Dashboard />
                </PageErrorBoundary>
              } />
              <Route path="/runs/:id" element={
                <PageErrorBoundary>
                  <RunBuilder />
                </PageErrorBoundary>
              } />
              <Route path="/settings" element={
                <PageErrorBoundary>
                  <Settings />
                </PageErrorBoundary>
              } />
            </Route>
          </Routes>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </PageErrorBoundary>
  )
}

export default App